import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-704f474f"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "SelectWarehouse"
};
var _hoisted_2 = {
  class: "detail"
};
var _hoisted_3 = {
  class: "info"
};
var _hoisted_4 = {
  class: "info"
};
var _hoisted_5 = {
  class: "info"
};
var _hoisted_6 = {
  class: "info"
};
var _hoisted_7 = {
  class: "info"
};
var _hoisted_8 = {
  class: "tabs"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_11 = {
  class: "pt-2 list"
};
var _hoisted_12 = {
  key: 1,
  class: "box"
};
var _hoisted_13 = {
  key: 0,
  class: "footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$list, _ctx$list2;
  var _component_van_cell = _resolveComponent("van-cell");
  var _component_material_item = _resolveComponent("material-item");
  var _component_van_cell_group = _resolveComponent("van-cell-group");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_cell, {
    title: "单据编号："
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.detail.release_no), 1)];
    }),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "领用人："
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.detail.u_name), 1)];
    }),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "领用部门："
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.detail.dept_name), 1)];
    }),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "仓库："
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.detail.warehouse_name), 1)];
    }),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "申请时间："
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.detail.create_time), 1)];
    }),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "单据状态："
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", {
        class: _normalizeClass(["info", {
          blue: _ctx.detail.release_status == 2
        }])
      }, _toDisplayString(_ctx.statusFormat(_ctx.detail.release_status)), 3)];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["feedingTab", {
        active: _ctx.tabActive === index
      }]),
      key: item.name,
      onClick: function onClick($event) {
        return _ctx.tabClick(item, index);
      }
    }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _hoisted_10], 10, _hoisted_9);
  }), 128))]), _createElementVNode("div", _hoisted_11, [(_ctx$list = _ctx.list) !== null && _ctx$list !== void 0 && _ctx$list.length ? (_openBlock(), _createBlock(_component_van_cell_group, {
    key: 0,
    inset: ""
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item, index) {
        return _openBlock(), _createBlock(_component_van_cell, {
          clickable: "",
          key: item.release_no
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_material_item, {
              item: item,
              index: index,
              show_status: _ctx.detail.release_status === 2,
              onUpdateList: _ctx.onSearch
            }, null, 8, ["item", "index", "show_status", "onUpdateList"])];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })) : _createCommentVNode("", true), !((_ctx$list2 = _ctx.list) !== null && _ctx$list2 !== void 0 && _ctx$list2.length) && _ctx.finished ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_c_no_data)])) : _createCommentVNode("", true)]), _ctx.detail.release_status === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_van_button, {
    block: "",
    type: "primary",
    onClick: _ctx.confirm
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("确认出库")];
    }),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true)]);
}